import React from 'react';
import ChatUI from './ChatUI';


function App() {
  return <ChatUI />;
}

export default App;

